<template lang="pug">
  v-container
    v-row(justify='center', align='center')
      v-col.text-center
        h1 Informe estadístico
    v-row
      v-col.text-center
        div
          v-container
            v-row.align-center.justify-center
              v-col(cols="12")
                iframe.iframe-statistical-report(src="https://datastudio.google.com/embed/reporting/1_tSOoblMIr9rM4Q-ZY2jcjEt505iXc2G/page/OnBOB")
</template>

<script>
export default {
  name: 'statistical-report'
}
</script>

<style>
.iframe-statistical-report {
  width: 100%;
  max-width: 1200px;
  height: 950px;
  background-color: white;
}
</style>
